'use strict';

exports.__esModule = true;
exports.Footer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _logoWhite = require('../../src/img/logo-white.svg');

var _logoWhite2 = _interopRequireDefault(_logoWhite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contactDetails = {
	doctifyPhone: '+44 20 3411 0652',
	doctifyPhoneLink: '+44 20 3411 0652',
	helloEmail: 'hello@doctify.co.uk'
};

var Footer = exports.Footer = function Footer(_ref) {
	var intl = _ref.intl;
	return _react2.default.createElement(
		'footer',
		{ id: 'Footer', className: _style.siteFooter },
		_react2.default.createElement(
			'div',
			{ className: _style.sitemap },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-md-12' },
						_react2.default.createElement(
							'div',
							{ className: _style.footerBox },
							_react2.default.createElement('img', { className: _style.logo,
								src: _logoWhite2.default,
								title: intl.formatMessage(_defaultMessages2.default.FIND_A_DOCTOR),
								alt: intl.formatMessage(_defaultMessages2.default.FIND_A_DOCTOR_ALT) })
						),
						_react2.default.createElement(
							'div',
							{ className: _style.footerBox },
							_react2.default.createElement(
								'h3',
								null,
								intl.formatMessage(_defaultMessages2.default.LEARN_ABOUT_DOCTIFY)
							),
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/career' },
										intl.formatMessage(_defaultMessages2.default.CAREERS)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/mission' },
										intl.formatMessage(_defaultMessages2.default.MISSION)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/patient-faqs' },
										intl.formatMessage(_defaultMessages2.default.FAQS_FOR_PATIENTS)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/blog/categories/in-the-press' },
										intl.formatMessage(_defaultMessages2.default.PRESS)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style.footerBox },
							_react2.default.createElement(
								'h3',
								null,
								intl.formatMessage(_defaultMessages2.default.GETTING_STARTED)
							),
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/contact' },
										intl.formatMessage(_defaultMessages2.default.CONTACT)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/join/doctors' },
										intl.formatMessage(_defaultMessages2.default.JOIN_DOCTIFY)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/social-media' },
										intl.formatMessage(_defaultMessages2.default.SOCIAL_MEDIA_AND_JOURNAL)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style.footerBox },
							_react2.default.createElement(
								'h3',
								null,
								intl.formatMessage(_defaultMessages2.default.LEGAL)
							),
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/cookie-policy' },
										intl.formatMessage(_defaultMessages2.default.COOKIE_POLICY)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/privacy-policy' },
										intl.formatMessage(_defaultMessages2.default.PRIVACY_POLICY)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/acceptable-use-policy' },
										intl.formatMessage(_defaultMessages2.default.ACCEPTABLE_USE_POLICY)
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/terms-and-conditions' },
										intl.formatMessage(_defaultMessages2.default.TERMS_AND_CONDITIONS)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style.footerBox },
							_react2.default.createElement(
								'h3',
								null,
								intl.formatMessage(_defaultMessages2.default.SOCIAL_MEDIA)
							),
							_react2.default.createElement(
								'div',
								{ className: _style.socialMediaHolder },
								_react2.default.createElement(
									'ul',
									{ className: 'list-inline' },
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'https://www.facebook.com/doctifyuk',
												target: '_blank', className: _style.facebook,
												title: intl.formatMessage(_defaultMessages2.default.FACEBOOK_TITLE) },
											_react2.default.createElement('i', { className: 'ion-social-facebook' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'https://twitter.com/doctifyuk',
												target: '_blank', className: _style.twitter,
												title: intl.formatMessage(_defaultMessages2.default.TWITTER_TITLE) },
											_react2.default.createElement('i', { className: 'ion-social-twitter' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'https://www.linkedin.com/company/doctify',
												target: '_blank', className: _style.linkedin,
												title: intl.formatMessage(_defaultMessages2.default.LINKED_IN_TITLE) },
											_react2.default.createElement('i', { className: 'ion-social-linkedin' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'https://instagram.com/doctify/', target: '_blank',
												className: _style.instagram,
												title: intl.formatMessage(_defaultMessages2.default.INSTAGRAM_TITLE) },
											_react2.default.createElement('i', { className: 'ion-social-instagram-outline' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'https://plus.google.com/u/0/111311986530482578105/posts/',
												target: '_blank', className: _style.googleplus,
												title: intl.formatMessage(_defaultMessages2.default.GOOGLE_PLUS_TITLE) },
											_react2.default.createElement('i', { className: 'ion-social-googleplus-outline' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: '/blog', target: '_blank', className: _style.blog,
												title: intl.formatMessage(_defaultMessages2.default.BLOG_TITLE) },
											_react2.default.createElement('i', { className: 'ion-chatbubble' })
										)
									)
								)
							)
						)
					)
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style.bottom },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'p',
						{ className: 'pull-left' },
						'\xA9 2016 Doctify Limited. All Rights Reserved.'
					),
					_react2.default.createElement(
						'ul',
						{ className: 'pull-right list-inline ' + _style.pipeSep },
						_react2.default.createElement(
							'li',
							null,
							intl.formatMessage(_defaultMessages2.default.CONTACT_US),
							_react2.default.createElement(
								'a',
								{ href: 'tel://' + contactDetails.doctifyPhoneLink },
								contactDetails.doctifyPhone
							)
						),
						_react2.default.createElement(
							'li',
							{ className: _style.lastChild },
							_react2.default.createElement(
								'a',
								{ href: 'mailto:' + contactDetails.helloEmail, title: intl.formatMessage(_defaultMessages2.default.CONTACT_US) },
								contactDetails.helloEmail
							)
						)
					)
				)
			)
		)
	);
};

Footer.displayName = 'Footer';

Footer.defaultProps = {};
exports.default = (0, _reactIntl.injectIntl)(Footer);


// WEBPACK FOOTER //
// ./components/footer/lib/components/footer.js